import React from 'react';

export default () => (
  <footer className="bdT ta-c p-30 fsz-sm c-grey-600">
    <span>
      Copyright © {`${new Date().getFullYear() }`} Developed by <a href="https://wayan.it" target="_blank" title="Wayan" rel="noopener noreferrer">Wayan</a>. All rights reserved.
    </span>
  </footer>
)